import components from './components';
import alerts from './features/alerts';
import app from './features/app';
import auth from './features/auth';
import gettingReady from './features/getting-ready';
import home from './features/home';
import noTeam from './features/no-team';
import platform from './features/platform';
import staff from './features/staff';

export default {
  components,
  features: {
    alerts,
    app,
    auth,
    getting_ready: gettingReady,
    home,
    no_team: noTeam,
    platform,
    staff,
  },
};
